
import Axios from "../common/http.js";

/**
 * 用户列表
 */
export const peopleList = (data) => {
    return Axios.post("/gorc/admin/user/users", data);
};
/**
 * 用户编辑
 */
export const editPeople = (data) => {
    return Axios.post("/gorc/admin/user/edit", data);
};
/**
 * 评论列表
 */
export const commentList = (params) => {
    return Axios.get("/gorc/admin/content/comment/list", {params});
};
/**
 * 评论删除
 */
export const deleteComment = (data) => {
    return Axios.post("/gorc/admin/content/comment/delete", data);
};